export default {
  newPreset: 'Nowe ustawienie wstępne',
};
